module.exports = __webpack_public_path__ + "img/minus_btn.edea1e3e.png";